import { CalculatorFieldOptionItem } from "../components/select-calculator-fields";

export const toggleField = ({ value, setFields }: {value: string, setFields: (arg: (prevValue: CalculatorFieldOptionItem[]) => CalculatorFieldOptionItem[]) => void}) => {
  setFields((prevValue: CalculatorFieldOptionItem[]) => {
    if (prevValue.length <= 0) return prevValue;
    return prevValue.map((item) => {
      if (item.value === value) {
        return { ...item, enabled: !item.enabled };
      }
      return item;
    });
  });
};
